module.exports = __webpack_public_path__ + "img/integrations-gtm.05edf8bd.png";